import type { AppointmentPhoto, ContactProperty, PropertyRecord } from "@shyne/shared/api";
import type { ReadAllResponse, uuid } from "@/interfaces";
import { api } from "@/lib/api";
import type { appointment_status } from "@/models/appointment.model";
import { toAppointmentLog, type AppointmentLogJoin } from "@/repositories/appointment-history";
import { readAppointmentPage, toApiFilters, toApiSortKey, toAppointmentJoin } from "@/repositories/appointment-records";
import type { AppointmentJoin } from "@/repositories/appointments.repository";

export type ContactAppointmentQuery = {
  property?: uuid;
  status?: appointment_status | "";
  search?: string;
  page: number;
  pageSize: number;
  sortKey: string;
  sortOrder: "asc" | "desc";
};

export const PropertyContactRepository = {
  mine: async (): Promise<ContactProperty[]> => (await api.me()).contactProperties,

  property: (id: uuid): Promise<PropertyRecord> => api.properties.get(id),

  async appointments({ property, status, search, page, pageSize, sortKey, sortOrder }: ContactAppointmentQuery): Promise<ReadAllResponse<AppointmentJoin>> {
    const filters = { property, search, status: status || undefined };
    const query = { ...toApiFilters(filters, null), sort: toApiSortKey(sortKey), order: sortOrder };
    const { items, total } = await readAppointmentPage(api.appointments.list, query, page, pageSize);
    return { data: items.map(toAppointmentJoin), count: total };
  },

  appointment: async (id: uuid): Promise<AppointmentJoin> => toAppointmentJoin(await api.appointments.get(id)),

  history: async (id: uuid): Promise<AppointmentLogJoin[]> => (await api.appointments.history(id)).items.map(toAppointmentLog),

  photos: async (id: uuid): Promise<AppointmentPhoto[]> => (await api.appointments.photos(id)).items,
};
